export const weekly = 'Weekly';
export const monthly = 'Monthly';
export const quarterly = 'Quarterly';
export const annual = 'Annual';
